var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 56,
    rx: 20,
    fill: "#710673"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.333 16.3335H19.6663C18.4997 16.3335 17.333 17.3835 17.333 18.6668V22.1785C17.333 23.0185 17.8347 23.7418 18.4997 24.1502V37.3335C18.4997 38.6168 19.783 39.6668 20.833 39.6668H37.1663C38.2163 39.6668 39.4997 38.6168 39.4997 37.3335V24.1502C40.1647 23.7418 40.6663 23.0185 40.6663 22.1785V18.6668C40.6663 17.3835 39.4997 16.3335 38.333 16.3335ZM31.333 30.3335H26.6663C26.0247 30.3335 25.4997 29.8085 25.4997 29.1668C25.4997 28.5252 26.0247 28.0002 26.6663 28.0002H31.333C31.9747 28.0002 32.4997 28.5252 32.4997 29.1668C32.4997 29.8085 31.9747 30.3335 31.333 30.3335ZM38.333 22.1668H19.6663V18.6668H38.333V22.1668Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.944e68fcc8c112fbd09abc2634a8a672.svg";
export { ForwardRef as ReactComponent };